<zaver-loading-dots
  [color]="colorService.getCeriseColorCode()"
  [diameter]="18"
></zaver-loading-dots>
